import { ReactNode, Children, isValidElement, cloneElement, ReactElement } from "react";
import { ScrollMenu, Props } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

type ScrollableTabsProps = Omit<Props, "children"> & {
	children: ReactNode;
};

export function ScrollableTabs({
	children,
	wrapperClassName = "w-100",
	scrollContainerClassName = "align-items-end text-nowrap",
	itemClassName = "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent",
	...rest
}: ScrollableTabsProps) {
	const items = Children.map(children, (child, index) => {
		if (isValidElement(child)) {
			const tabIndex = `tab-${index}`;

			return cloneElement(child, {
				key: tabIndex,
				itemId: tabIndex,
			});
		}
		return child;
	});

	return (
		<ScrollMenu
			wrapperClassName={wrapperClassName}
			scrollContainerClassName={scrollContainerClassName}
			itemClassName={itemClassName}
			{...rest}
		>
			{items as ReactElement[]}
		</ScrollMenu>
	);
}
